// extracted by mini-css-extract-plugin
export default {"wrap":"Belt_wrap__9Oebs","row":"Belt_row__cI-Du","cateWrap":"Belt_cateWrap__klilU"};